@if (isStarted) {
<av-tooltip
  message="Chat"
  position="right"
  [enabled]="!isChatOpen"
  [@slideFromLeft]="true"
>
  <button
    avButton
    ofType="icon"
    size="sm"
    [color]="isChatOpen ? 'basic' : 'primary'"
    id="btn-chat-toggle"
    (click)="toggleChat()"
    data-tid="conversation-launcher/toggle-chat"
    [attr.aria-label]="'Chat' | translate"
  >
    @if (!isChatOpen || isWidget) {
    <av-icon name="chat-bubble"></av-icon>
    } @if (!isWidget && isChatOpen) {
    <av-icon name="close-big"></av-icon>
    }
  </button>
</av-tooltip>
} @if (!isWidget && isChatOpen) {
<app-conversation
  [@slideFromLeft]="true"
  class="conversation"
></app-conversation>
}
